import {combineReducers} from 'redux';
import {persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import {i18n, globalMessage} from '../common';
import {auth} from '../modules/Auth';

export const rootReducer = () =>
  combineReducers({
    i18n,
    auth,
    globalMessage
  });

const persistConfig = {
  key: 'atzmai-user-client-root',
  storage,
  blacklist: ['globalMessage']
};

const persistedReducer = () => persistReducer(persistConfig, rootReducer());

export default persistedReducer;
